// @flow

/**
 * Module dependencies.
 */

import { getContext } from 'recompose';
import PropTypes from 'prop-types';

/**
 * Export with sticky.
 */

export const withSticky = getContext({
  isSticky: PropTypes.bool,
  setSticky: PropTypes.func
});



// WEBPACK FOOTER //
// ../src/client/components/core/sticky-navbar/with-sticky.js